import React from "react"

import { RJSFSchema } from "shared/types/RJSF"

import { RJSFFormFieldFactory } from "./RJSFFormFieldFactory"
import { RJSFFormFieldProps } from "./types"

interface RJSFFormFieldArrayProps {
  prefix?: string
  schemas: RJSFSchema[]
  isDisabled?: boolean

  FieldInformationRenderer?: React.ComponentType<RJSFFormFieldProps>
}

export const RJSFFormFieldArray = React.memo(
  ({
    schemas,
    isDisabled,
    prefix,
    FieldInformationRenderer
  }: RJSFFormFieldArrayProps) => (
    <>
      {schemas.map((field, index) => (
        <RJSFFormFieldFactory
          key={`${prefix}-${index}` as string}
          path={prefix as string}
          schema={field as RJSFSchema}
          isDisabled={isDisabled}
          FieldInformationRenderer={FieldInformationRenderer}
        />
      ))}
    </>
  )
)
